    <template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <!-- date, payment_type, group ,customer, cashier, salesman, include salesman, manual_invoice -->
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Date"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Payment Types">
                                        <a-select mode="multiple" v-model="inputPaymentTypes" showSearch placeholder="All Payment Types" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in paymentTypeOptions" :key="option.id" :value="option.id">{{option.code}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Customer">
                                        <a-select mode="multiple" v-model="inputCustomer" showSearch placeholder="All Customers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in customerOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>

        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Cashier">
                                        <a-select mode="multiple" v-model="inputCashier" showSearch placeholder="All Cashiers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in cashierOptions" :key="option.id" :value="option.id">{{option.first_name}} {{option.last_name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Salesman">
                                        <a-select mode="multiple" v-model="inputSalesman" showSearch placeholder="All Salesman" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in salesmanOptions" :key="option.id" :value="option.id">{{option.name }}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>


                            <base-checkbox class="mb-3" v-model="isIncludeSalesman">
                                Include Salesman
                            </base-checkbox>

                            <base-checkbox class="mb-3" v-model="isShowManualInvoice">
                                Show Manual Invoice
                            </base-checkbox>

                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" csv-title="POSAllPaymentTypesPaymentReport">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" name="POSAllPaymentTypesPaymentReport" type="xlsx" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import VueJsonToCsv from 'vue-json-to-csv';
    import {
        mapState,
        mapActions
    } from 'vuex'
    import { getReportDescription } from '../../utilities';

    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'pd.terminal_id',
                groupOptions: [
                    {key: 'pd.terminal_id', value: 'Terminal'},
                    {key: 'pd.user_id', value: 'Cashier'},
                    {key: 'pd.customer_id', value: 'Customer'},
                    {key: 'pd.salesman_id', value: 'Salesman'},
                    {key: 'pd.user_id,pd.salesman_id', value: 'Cashier/Salesman'},
                ],
                inputSite: [],
                inputTerminal: [],
                inputCashier: [],
                inputPaymentTypes: [],
                inputCustomer: [],
                inputSalesman: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                cashierOptions: [],
                customerOptions: [],
                salesmanOptions: [],
                paymentTypeOptions: [],
                inputSortBy: 'grouper_id',
                sortOptions: [
                    {key: 'terminal', value: 'Terminal'},
                    {key: 'cashier', value: 'Cashier'},
                    {key: 'payment_type', value: 'Payment Type'}
                ],
    
                birSalesReports: [],
                inputLocation: [],
                locationOptions: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                JsonData: [],
                inputBrand: null,
                brandOptions: [],
                subBrandOptions: [],
                inputSubsalesmans: [],
                reportDescription: '',
                isIncludeSalesman: false,
                isShowManualInvoice: false,
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            // //Start get valid Terminals
            // var terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + secureStorage.getItem("defaultSiteId"), null);
            // component_x.terminalOptions = terminals;
            // component_x.sort(component_x.terminalOptions);
            // //End get valid Terminals
                
            //Start get valid payment types
            var payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
            component_x.paymentTypeOptions = payment_types;
            component_x.sort(component_x.paymentTypeOptions);
            //End get valid payment types

            //Start get valid Cashiers
            var cashiers = await HTTPRequest.getRequest(component_x.endPoint + "users/get_valid_cashiers", null);
            component_x.cashierOptions = cashiers;
            // component_x.sort(component_x.cashierOptions);

            let customers = await HTTPRequest.getRequest(component_x.endPoint + "/customers/get_valid_customers", null);
            component_x.customerOptions = customers;

            let salesmanOptions = await HTTPRequest.getRequest(component_x.endPoint + "/salesmen/get_valid_salesmen", null);
            component_x.salesmanOptions = salesmanOptions;

            //End get valid Cashiers
            this.reportDescription = await getReportDescription(this.currentProfile)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['endPoint', 'categoriesOptions']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        watch: {
    
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            // async onLocationChange(){
            //     // alert(this.inputLocation);
            //     this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
            //     this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
            //     this.inputSite = this.siteOptions.map( s => s.id);
            // },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            showFixed(num, fixed) {
                fixed = fixed || 0;
                fixed = Math.pow(10, fixed);
                return Math.floor(num * fixed) / fixed;
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advamcedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }
                let site_filter, date_filter, cashier_filter, customer_filter, salesman_filter, payment_type_filter
                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                if(this.inputCashier != undefined && this.inputCashier.length > 0 && this.inputCashier != []){
                    let cashier = this.cashierOptions.filter(x => this.inputCashier.includes(x.id)).map(x => x.name)
                    cashier_filter = "Cashier: " + cashier 
                }else{
                    cashier_filter = "Cashier: All Cashiers"
                }

                if(this.inputCustomer != undefined && this.inputCustomer.length > 0 && this.inputCustomer != []){
                    let customers = this.customerOptions.filter(x => this.inputCustomer.includes(x.id)).map(x => x.name)
                    customer_filter = "Customer: " + customers 
                }else{
                    customer_filter = "Customer: All Customers"
                }

                if(this.inputSalesman != undefined && this.inputSalesman.length > 0 && this.inputSalesman != []){
                    let salesmans = this.brandOptions.filter(x => this.inputSalesman.includes(x.id)).map(x => x.name)
                    salesman_filter = "Salesman: " + salesmans 
                }else{
                    salesman_filter = "Salesman: All Salesmans"
                }

                if(this.inputPaymentTypes != undefined && this.inputPaymentTypes.length > 0 && this.inputPaymentTypes != []){
                    let payment_types = this.brandOptions.filter(x => this.inputPaymentTypes.includes(x.id)).map(x => x.code)
                    payment_type_filter = "Payment Type: " + payment_types 
                }else{
                    payment_type_filter = "Payment Type: All Payment Type"
                }
                
                date_filter = `For the Period of ${from_header} to ${to_header}`



                let design_x = 0
                let design_y = 0

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "payment_type": this.inputPaymentTypes.toString(),
                    "filter_by": this.inputGroupBy,
                    "cashier": this.inputCashier.toString(),
                    "customer": this.inputCustomer.toString(),
                    "salesman": this.inputSalesman.toString(),
                    "includeSalesman": this.isIncludeSalesman,
                    "includeManualInvoice": this.isShowManualInvoice,
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_wallet_payments?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                let headers = [];
                if(this.isIncludeSalesman == 'true' || this.isIncludeSalesman == true ){
                    headers = [
                            [
                                {content: 'Cashiers', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Trans. ID', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Date/Time', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Salesman', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Customer', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Ref Code', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Amount Tender', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Payment Amount', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Transaction Amount Due', styles: {halign: 'center', valign: 'auto'}}
                            ]
                        ]
                }else{
                    headers = [
                            [
                                {content: 'Cashiers', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Trans. ID', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Date/Time', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Customer', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Ref Code', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Amount Tender', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Payment Amount', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Transaction Amount Due', styles: {halign: 'center', valign: 'auto'}}
                            ]
                        ]
                }
                if(get_request.length > 0){
                    // Iterate through siteSpecific data
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    for(let x=0; x < siteSpecific.length; x++){
                        this.detailedSoldOutReport = siteSpecific[x].report_details

                        if(x > 0 && this.detailedSoldOutReport.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.detailedSoldOutReport.length > 0){

                            for(let i=0; i < this.detailedSoldOutReport.length; i++){
                                let reportLine = this.detailedSoldOutReport[i]

                                let detail = []
                                if(this.isIncludeSalesman == 'true' || this.isIncludeSalesman == true ){
                                    detail = [
                                        reportLine.cashier,reportLine.trans_id,reportLine.document_date, reportLine.salesman_name, reportLine.customer_name,
                                        reportLine.reference_code, 
                                        reportLine.tender  == '' ? '' : this.convertToCurrency(Number(reportLine.tender)), 
                                        reportLine.amount  == '' ? '' : this.convertToCurrency(Number(reportLine.amount)),
                                        reportLine.amount_due == '' ? '' : this.convertToCurrency(Number(reportLine.amount_due))
                                    ]
                                }else{
                                    detail = [
                                        reportLine.cashier,reportLine.trans_id,reportLine.document_date, reportLine.customer_name,
                                        reportLine.reference_code, 
                                        reportLine.tender  == '' ? '' : this.convertToCurrency(Number(reportLine.tender)), 
                                        reportLine.amount  == '' ? '' : this.convertToCurrency(Number(reportLine.amount)),
                                        reportLine.amount_due == '' ? '' : this.convertToCurrency(Number(reportLine.amount_due))
                                    ]
                                }
                            
                                reportData.push(Object.assign({}, detail))

                            }
                        }


                        design_x = 330
                        design_y = 200
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"POS All Payment Types Payment Report by" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                        doc.text(15,30,date_filter);
                        doc.text(15,34,site_filter);
                        doc.text(15,38,cashier_filter);
                        doc.text(15,42,customer_filter);
                        doc.text(15,46,salesman_filter);
                        doc.text(15,50,payment_type_filter);
                        // doc.text(15,54,department_filter);
                        // doc.text(15,58,order_filter);

                        let colStyles = {}
                        if(this.isIncludeSalesman == 'true' || this.isIncludeSalesman == true ){
                            colStyles = {
                                0: {cellWidth: 'auto',halign: 'left'},
                                1: {cellWidth: 'auto',halign: 'center'},
                                2: {cellWidth: 'auto',halign: 'left'},
                                3: {cellWidth: 'auto',halign: 'left'},
                                4: {cellWidth: 'auto',halign: 'left'},
                                5: {cellWidth: 'auto',halign: 'left'},
                                6: {cellWidth: 'auto',halign: 'right'},
                                7: {cellWidth: 'auto',halign: 'right'},
                                8: {cellWidth: 'auto',halign: 'right'},
                                9: {cellWidth: 'auto',halign: 'right'},
                            }
                        }else{
                            colStyles = {
                            0: {cellWidth: 'auto',halign: 'left'},
                            1: {cellWidth: 'auto',halign: 'center'},
                            2: {cellWidth: 'auto',halign: 'left'},
                            3: {cellWidth: 'auto',halign: 'left'},
                            4: {cellWidth: 'auto',halign: 'left'},
                            5: {cellWidth: 'auto',halign: 'right'},
                            6: {cellWidth: 'auto',halign: 'right'},
                            7: {cellWidth: 'auto',halign: 'right'},
                            8: {cellWidth: 'auto',halign: 'right'},
                            }
                        }


                        doc.autoTable({
                            startY: 63,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.3, fontSize: 10,
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[2] == '-' ){
                                    data.cell.styles.fillColor = [0, 0, 0, 0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[2] == null || data.row.raw[2] == '')){
                                    // if column date and time is blank
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });


                    }
                    // end loop
                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "POSAllPaymentTypesPaymentReport", design_x + 65 , design_y + 75, i, pageCount)
                    }
                    // await window.open(URL.createObjectURL(doc.output("blob")))
                    doc.save(`POSAllPaymentTypesPaymentReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            async groupByPaymentAndTerminal(reportLines) {
                let grouped = {};

                reportLines.forEach((reportLine) => {
                    let paymentType = reportLine.payment_type_code;
                    let grouperName = reportLine.grouper_name;

                    if (!grouped[paymentType]) {
                    grouped[paymentType] = {};
                    }

                    if (!grouped[paymentType][grouperName]) {
                    grouped[paymentType][grouperName] = [];
                    }

                    grouped[paymentType][grouperName].push(reportLine);
                });

                return grouped;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }
                let site_filter, date_filter
                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                date_filter = `For the Period of ${from_header} to ${to_header}`

                let design_x = 0
                let design_y = 0

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "payment_type": this.inputPaymentTypes.toString(),
                    "filter_by": this.inputGroupBy,
                    "cashier": this.inputCashier.toString(),
                    "customer": this.inputCustomer.toString(),
                    "salesman": this.inputSalesman.toString(),
                    "includeSalesman": this.isIncludeSalesman,
                    "includeManualInvoice": this.isShowManualInvoice,
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_wallet_payments?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ['Cashier',' Trans ID',' Date/Time',' Customer','Ref Code','Amount Tender','Payment Amount','Transaction Amount Due'];
                    if(this.isIncludeSalesman == 'true' || this.isIncludeSalesman == true ){
                        headers = ['Cashier',' Trans ID',' Date/Time','Salesman',' Customer','Ref Code','Amount Tender','Payment Amount','Transaction Amount Due']
                    }
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let detail = []
                                if(this.isIncludeSalesman == 'true' || this.isIncludeSalesman == true ){
                                    detail = [
                                        reportLine.cashier,reportLine.trans_id,reportLine.document_date, reportLine.salesman_name, reportLine.customer_name,
                                        reportLine.reference_code, 
                                        reportLine.tender  == '' ? '' : this.convertToCurrency(Number(reportLine.tender)), 
                                        reportLine.amount  == '' ? '' : this.convertToCurrency(Number(reportLine.amount)),
                                        reportLine.amount_due == '' ? '' : this.convertToCurrency(Number(reportLine.amount_due))
                                    ]
                                }else{
                                    detail = [
                                        reportLine.cashier,reportLine.trans_id,reportLine.document_date, reportLine.customer_name,
                                        reportLine.reference_code, 
                                        reportLine.tender  == '' ? '' : this.convertToCurrency(Number(reportLine.tender)), 
                                        reportLine.amount  == '' ? '' : this.convertToCurrency(Number(reportLine.amount)),
                                        reportLine.amount_due == '' ? '' : this.convertToCurrency(Number(reportLine.amount_due))
                                    ]
                                }
                                reportData.push(Object.assign({}, detail))
                            }

                        }
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["POS All Payment Types Payment Report by " + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },

            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_salesmans/get_valid_sub_salesmans?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubsalesmans)
                }
            },

            async clearSubBrand() {
                this.inputSubsalesmans = [];
            },
        }
    };
</script>

<style></style>
